import { useEffect, useState } from 'react';
import QRCode from 'react-qr-code';
import { _zzsurvey_ajax } from '../utils/zz/zz-zzsurvey-ajax-adapter';
import FormFieldGenerator from './FormFieldGenerator';
import JSDisplayValue from "./JSDisplayValue";
import SpinnerClassic from './SpinnerClassic';


/*
https://www.npmjs.com/package/react-qr-code
https://www.dhiwise.com/post/how-to-generate-and-display-qr-codes-in-your-react-app
<QRCode value={url} size={128} style={{ margin: '20px' }} />
*/

//
const _temp_make_qr_code_url_v1_frontend = (cdp_sifra, cdp_customer_id, consent_id) => {
  const origin = window.location.origin; // "http://localhost:3000"
  /*
  let _cdp_sifra = '';
  if (typeof cdp_sifra === 'string') {
    _cdp_sifra = cdp_sifra;
  }
  */
  // const url = origin + '/admin/sign?cdp_sifra=' + cdp_sifra + '&consent_id=' + consent_id + '&cdp_customer_id=' + cdp_customer_id;
  const url = origin + '/signatures?cdp_sifra=' + cdp_sifra + '&consent_id=' + consent_id + '&cdp_customer_id=' + cdp_customer_id;
  return url;
};


// DEFAULT COMPONENT
const ZZTempQRCodeForSignConsent = (props) => {
  const {
    // cdp_sifra,
    // cdp_customer_id,
    // consent_id,
    formState,
  } = props;
  const {
    cdp_sifra,
    cdp_customer_id,
    consent_id,
  } = formState;


  const [state, setState] = useState({
    fetching: false,
    signature_url: null,
  });
  useEffect(() => {
    //
    if (consent_id > 0) {
      setState({
        fetching: true,
        signature_url: null,
      });
      _zzsurvey_ajax.generateSignatureUrl(cdp_customer_id, consent_id)
        .then(response => {
          console.log('response generateSignatureUrl', response);
          /*
          {
              "message": "Successfully generated URL for signature page.",
              "url": "https://dev.ratemyservice.rs/signatures?token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjZHBfY3VzdG9tZXJfaWQiOiIyIiwiY29uc2VudF9pZCI6IjEiLCJpYXQiOjE3NDY2MzAwODQsImV4cCI6MTc0NjYzMzY4NH0.UUHQEuxVH6ZUWdPswALD1RANyIDDSn5leQCFb3hLfUc"
          }
          */
          if (response?.data?.url) {
            const url = response.data.url;
            /*
            const url = new URL(response.data.url); //
            console.log('URL', url);
            */
            console.log('url', url);
            setState({
              fetching: false,
              signature_url: url,
            });
          } else {
            setState({
              fetching: false,
              signature_url: null,
            });
          }
        })
    }
    //
  }, [consent_id]);

  //
  /*
  let url = "https://www.example.com";
  // url = 'http://localhost:3000/admin/sign?cdp_sifra=123';
  url = _temp_make_qr_code_url_v1_frontend(cdp_sifra, cdp_customer_id, consent_id);
  */
  const url = state.signature_url;

  return (
    <>
      <div>
        <div className="zzsurvey__layout-page-body-section-dev">
          <div>props:</div>
          <JSDisplayValue val={props} />
        </div>
        <h3>QR code for sign form</h3>
        {
          consent_id > 0 ? (null) : (
            <div className="zzsurvey__editor__error-msg"><i>You must choose Consent ID!</i></div>
          )
        }
        {
          state.fetching === true ? (
            <>
              <div className="uu-gap-standalone-8px"></div>
              <SpinnerClassic />
              <div className="uu-gap-standalone-8px"></div>
            </>
          ) : (
            <>
              {
                url && (
                  <>
                    <p>Scan QR code from your mobile/tablet device and sign form for customer will be shown. Than give device to customer to sign.</p>
                    <div className="zzsurvey__qr-code-wrapper">
                      <QRCode value={url} size={192} />
                    </div>

                    <h3>Or open QR code link manually</h3>
                    <p>QR code URL: <a target="_blank" rel="noopener noreferrer" href={url}>{url}</a></p>
                    <FormFieldGenerator
                      fieldDefinition={{
                        "type": "input_text",
                        "params": {
                          "readonly": true,
                          "label": "QR code URL",
                          "name": "url",
                          // "placeholder": "http://ratemyservice.rs",
                          // "w": 320
                        }
                      }}
                      value={url}
                      handleChange={() => { }}
                    />
                  </>
                )
              }
            </>
          )
        }
      </div>
    </>
  );
};

export default ZZTempQRCodeForSignConsent;